<template>
   <v-row>
      <v-dialog :key="showDialog" v-model="showDialog" scrollable max-width="70%" :retain-focus="false">
         <v-skeleton-loader
         v-if="loading"
            type="article, actions"
         ></v-skeleton-loader>
         <v-card v-if="!loading">
            <v-card-title style="padding: 10px">
               <v-col cols="12">
                  <span style="font-size: 20px;">
                     {{ isNew ? $t('wkt.admin.news.edit-window.new_news_title') : $t('wkt.admin.news.edit-window.edit_news_title' )}}
                  </span>
               </v-col>
            </v-card-title>
            <v-card-text style="padding-bottom: 0;">
               <v-container fluid @wheel="onWheel">
                  <v-form ref="form">
                     <div>
                        <v-row>
                           <v-col col-xl-4 col-md-5 col-sm-12>
                              <v-card
                              height="400px"
                              width="400px">
                                 <v-img
                                 height="350px"
                                 :src="imagePath">
                                 </v-img>
                                 <v-card-actions>
                                    <v-btn
                                       elevation="2"
                                       fab
                                       color="#185EA9"
                                       style="bottom: 35px; left: 82%;"
                                       >
                                          <v-icon
                                             class="relative"
                                             style="left: 16px;"
                                             color="#FFFFFF"> cloud_upload
                                          </v-icon>
                                          <v-file-input style="opacity: 0;"
                                             v-model="file"
                                             dense
                                             hide-input
                                             @change="uploadFile()"/>
                                    </v-btn>
                                    <v-progress-linear
                                    :active="loadingImage"
                                    :indeterminate="loadingImage"
                                    absolute
                                    bottom
                                    color="primary"
                                    ></v-progress-linear>
                                 </v-card-actions>
                              </v-card>
                                 <v-container v-if="imageError">
                                    <div style="border-top: #ff5252 solid 1px; max-width:375px">
                                       <span style="color:#ff5252">{{ imageError }}</span>
                                    </div>
                                 </v-container>
                           </v-col>
                           <v-col class="mt-5" col-xl-8 col-md-7 col-sm-12>
                              <v-row>
                                 <v-col cols="5">              
                                    <v-text-field
                                    v-model="creationDate"
                                    :label="$t('wkt.admin.news.edit-window.created')"
                                    autocomplete="none"
                                    :rules="[validationRules.required]"
                                    disabled>
                                    </v-text-field>
                                 </v-col>
                              </v-row>
                              <v-row>
                                 <v-col cols="5">              
                                    <v-menu
                                       ref="fromDateMenu"
                                       v-model="fromDateMenu"
                                       :close-on-content-click="false"
                                       transition="scale-transition"
                                       offset-y
                                       max-width="290px"
                                       min-width="auto"
                                    >
                                    <template v-slot:activator="{ on, attrs }">
                                       <v-text-field
                                          v-model="fromDateFormatted"
                                          :disabled="isReadOnly"
                                          :label="$t('wkt.admin.news.edit-window.start_date_placeholder')"
                                          v-on="on"
                                          v-bind="attrs"
                                          @blur="fromDate = formatLocalDateToISOStringDate(fromDateFormatted)"
                                          :rules="[validationRules.required]" />
                                    </template>
                                    <v-date-picker
                                       v-model="fromDate"
                                       :first-day-of-week="1" 
                                       :locale="$i18n.locale"
                                       no-title
                                       @input="updateFormattedDate()"
                                       @change="fromDateMenu = false"
                                    />
                                    </v-menu>
                                 </v-col>
                                 <v-col cols="5">                           
                                    <v-text-field
                                       v-model="startTime"
                                       :disabled="isReadOnly"
                                       :label="$t('wkt.admin.news.edit-window.start_time_placeholder')"
                                       v-mask="'##:##'"
                                       placeholder="00:00"
                                       autocomplete="none"
                                       :rules="[validationRules.required, timeStartRule]" />
                                 </v-col>
                                 <v-col cols="5">    
                                    <v-menu
                                       ref="toDateMenu"
                                       v-model="toDateMenu"
                                       :close-on-content-click="false"
                                       transition="scale-transition"
                                       offset-y
                                       max-width="290px"
                                       min-width="auto"
                                    >
                                    <template v-slot:activator="{ on, attrs }">
                                       <v-text-field
                                          v-model="toDateFormatted"
                                          :disabled="isReadOnly"
                                          :label="$t('wkt.admin.news.edit-window.end_date_placeholder')"
                                          :error-messages="errorMessages"
                                          v-on="on"
                                          v-bind="attrs"
                                          @blur="toDate = formatLocalDateToISOStringDate(toDateFormatted)"
                                          :rules="mustBeValidatedEndTime ? [validationRules.required] : []" />
                                    </template>
                                    <v-date-picker
                                       v-model="toDate"
                                       :first-day-of-week="1" 
                                       :locale="$i18n.locale"
                                       no-title
                                       @input="updateFormattedDate()"
                                       @change="toDateMenu = false" />
                                    </v-menu>
                                 </v-col>
                                 <v-col cols="5">
                                    <v-text-field
                                    v-model="endTime"
                                    :disabled="isReadOnly"
                                    :label="$t('wkt.admin.news.edit-window.end_time_placeholder')"
                                    v-mask="'##:##'"
                                    :error-messages="errorMessages"
                                    placeholder="00:00"
                                    autocomplete= "none"
                                    :rules ="mustBeValidatedToDate ? [validationRules.required, timeRule] : [timeRule] "/>
                                 </v-col>
                              </v-row>
                           </v-col>
                        </v-row>
                        <!-- Otros inputs -->
                        <v-row>
                           <v-col>
                              <TargetManager
                                 v-model="targetManagerType"
                                 :types="types"
                                 :filterByProfile="true"
                                 :disabled="isReadOnly"

                                 :workplaceIdsAsString="workPlacesList.length > 0
                                    ? workPlacesList.join(',')
                                    : ''"

                                 :departmentIdsAsString="departmentsList.length > 0
                                    ? departmentsList.join(',')
                                    : ''"

                                 :legalEntityIdsAsString="legalEntitiesList.length > 0
                                    ? legalEntitiesList.join(',')
                                    : ''"

                                 :projectIdsAsString="projectsList.length > 0
                                    ? projectsList.join(',')
                                    : ''"

                                 :targetLabel="$t('wkt.admin.news.edit-window.receiver_placeholder')"

                                 @update:workplaceIdsAsString="(newString) => {
                                    this.workPlacesList = newString
                                       ? newString.split(',').map(s => Number(s))
                                       : []
                                 }"

                                 @update:departmentIdsAsString="(newString) => {
                                    this.departmentsList = newString
                                       ? newString.split(',').map(s => Number(s))
                                       : []
                                 }"

                                 @update:legalEntityIdsAsString="(newString) => {
                                    this.legalEntitiesList = newString
                                       ? newString.split(',').map(s => Number(s))
                                       : []
                                 }"

                                 @update:projectIdsAsString="(newString) => {
                                    this.projectsList = newString
                                       ? newString.split(',').map(s => Number(s))
                                       : []
                                 }"
                              />
                           </v-col>
                           <v-col cols="12">                
                              <v-text-field
                                 v-model="formTitle"
                                 :disabled="isReadOnly"
                                 :label="$t('wkt.admin.news.edit-window.title')"
                                 autocomplete="none"
                                 :rules="[validationRules.required]" />
                           </v-col>
                           <v-col cols="12">                
                              <v-text-field
                                 v-model="formSummary"
                                 :disabled="isReadOnly"
                                 :label="$t('wkt.admin.news.edit-window.summary')"
                                 autocomplete="none"
                                 :rules="[validationRules.required]" />
                           </v-col>
                           <v-col cols="12">
                              <TiptapVuetify
                                 :vuetify-instance="$vuetify"
                                 @wheel="onWheel"
                                 v-model="data.content"
                                 :placeholder="editorPlaceholder"
                                 :extensions="extensions"
                                 :card-props="{ flat: true }"
                                 style="border: 1px solid rgba(0,0,0,.12);; border-radius: 6px; min-height: 200px;"/>
                                 <v-container v-if="contentError">
                                    <div style="border-top: #ff5252 solid 1px">
                                       <span style="color:#ff5252">{{ contentError }}</span>
                                    </div>
                                 </v-container>
                           </v-col>

                           <v-col cols="6">
                              <v-switch
                                 v-model="data.enabled"
                                 :disabled="isReadOnly"
                                 :label="$t('wkt.admin.news.edit-window.enabled')"
                              ></v-switch>
                           </v-col>
                           <v-col cols="6">
                              <v-switch
                                 v-model="data.featured"
                                 :disabled="isReadOnly"
                                 :label="$t('wkt.admin.news.edit-window.featured')"
                              ></v-switch>
                           </v-col>
                        </v-row>
                        </div>
                  </v-form>
               </v-container>
				</v-card-text>
            <v-divider></v-divider>
				<v-card-actions>
               <v-btn v-if="!isNew" color="#ff0000" :disabled="isReadOnly" @click="confirmDelete()">
                  <v-icon left color="#ffffff">delete</v-icon>
                  <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
               </v-btn>
               <v-spacer></v-spacer>
               <v-btn color="#185EA9" text @click="onSave()" :disabled="isReadOnly" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
               <v-btn text @click="onCancel()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
      <ConfirmDialog ref="dlgConfirm"
         v-bind:title="$t('wkt.admin.news.confirm-dialog.title')"
         v-bind:message="$t('wkt.admin.news.confirm-dialog.text')"
         v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
         v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
         v-on:confirmed="deleteItem()" />
   </v-row>	
</template>

<script>
import BaseModule from '../../common/BaseModule.js';
import ConfirmDialog from '../../common/ConfirmDialog';
import api from '../../../api/worktime';
import gwt from '../../../api/gwt';
import { Constants } from '../../common/Constants';
import CommonFormatter from '../../common/CommonFormatter.js';
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, Image, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify';
import TargetManager from "../../common/TargetManager.vue";

export default {
   name: 'NewsDialog',
   mixins: [BaseModule, CommonFormatter],
   components: {
      ConfirmDialog, TiptapVuetify,TargetManager
   },
   data() {
      return {
         isNew: false,
         showDialog: false,
         formTitle: '',
         formSummary: '',
         creationDate: null,
         deleteOnCancel: false,
         loading: true,
         loadingImage: false,
         file: null,
         data: {},
         targetManagerType: 0,
         types: [
         { id: 0, name: this.$t('wkt.admin.news.edit-window.receiver_company') },
         { id: 1, name: this.$t('wkt.admin.news.edit-window.receiver_group') },
         { id: 2, name: this.$t('wkt.admin.news.edit-window.receiver_project') }
         ],
         workPlacesList: [],
         departmentsList: [],
         legalEntitiesList: [],
         projectsList: [],

         extensions: [
            History,
            Blockquote,
            Link,
            Underline,
            Strike,
            Italic,
            ListItem,
            BulletList,
            OrderedList,
            [Heading, {
            options: {
               levels: [1, 2, 3]
            }
            }],
            Bold,
            Code,
            HorizontalRule,
            Paragraph,
            HardBreak,
            Image     
         ],
         editorPlaceholder: '',
         fromDate: null,
         fromDateFormatted: '',
         fromDateMenu: false,
         toDate: null,
         toDateFormatted: '',
         toDateMenu: false,
         startTime: null,
         endTime: null,
         imageError: '',
         contentError: '',
         errorMessages: '',
         profile: null, sessionEmployee: null,
         ignoreTargetTypeChange: false,
      }
   },
   computed: {
      imagePath() {
         if (!this.data.imagePath || this.data.imagePath.trim().length === 0) {
            return "img/default-news.jpeg";
         }

         const bucketName = "worktime-dev";
         return "https://storage.googleapis.com/" + bucketName + "/" + this.data.imagePath;
      },
      mustBeValidatedToDate() {
         return !!this.toDate;
      },
      mustBeValidatedEndTime() {
         return !!this.endTime;
      },
      validateStartTime() {
         return !!this.startTime;
      },
      sessionModuleNews() {
         return this.profile?.moduleNews;
      },
      sessionUserIsSuperAdmin() {
         return this.sessionEmployee?.employee?.isSuperAdmin === true;
      },
      isReadOnly() {
         return (
         this.sessionModuleNews === Constants.ALLOW_READ_ONLY &&
         !this.sessionUserIsSuperAdmin
         );
      },
   },
   watch: {
      fromDate() {
         this.updateFormattedDate();
      },
      toDate() {
         this.updateFormattedDate();
      },
      targetManagerType(newVal, oldVal) {
         if (this.ignoreTargetTypeChange || newVal === oldVal) return;
         this.resetTargetLists(newVal);
      },
   },
   methods: {
      getRequestErrorStatus(error) {
         return error && error.response ? error.response.status : null;
      },
      getRequestErrorMessage(error, fallbackKey, fallbackText) {
         if (error && error.response && error.response.data && typeof error.response.data === 'string') {
            return error.response.data;
         }
         return this.$t(fallbackKey) || fallbackText;
      },
      onWheel(event) {
         event.stopPropagation();
      },
      resetTargetLists(currentType) {
         switch (currentType) {
         case 0: // Toda la empresa
            this.workPlacesList = [];
            this.departmentsList = [];
            this.legalEntitiesList = [];
            this.projectsList = [];
            break;
         case 1: // Centros + Departamentos
            this.projectsList = [];
            break;
         case 2: // Proyectos
            this.workPlacesList = [];
            this.departmentsList = [];
            this.legalEntitiesList = [];
            break;
         }
      },
      open(action, payload) {
         this.ignoreTargetTypeChange = true; 
         this.profile = gwt.getSessionProfile();
         this.sessionEmployee = gwt.getSessionInformation();
         this.editorPlaceholder = this.$t('wkt.admin.news.edit-window.editor_placeholder');
         this.errorMessages = '';
         this.showDialog = true;

         if (this.$refs.form) {
         this.$refs.form.resetValidation();
         }

         // estamos creando un elemento
         if (!payload) {
            this.isNew = true;
            this.loading = true;
            this.createNewsOnStart();
            return;
         }

         this.isNew = false;
         this.loading = true;

         api.getNewsById(payload,
            (res) => {
               this.deleteOnCancel = false;
               this.data = res;
               this.formTitle = res.title;
               this.formSummary = res.summary;

               this.workPlacesList  = this.getWorkplaceIds();
               this.departmentsList = this.getDepartmentsIds();
               this.legalEntitiesList = this.getLegalEntityIds();
               this.projectsList    = this.getProjectIds();

               if (this.projectsList.length > 0) {
                  this.targetManagerType = 2;
               } else if (this.workPlacesList.length > 0 || this.departmentsList.length > 0 || this.legalEntitiesList.length > 0) {
                  this.targetManagerType = 1;
               } else {
                  this.targetManagerType = 0;
               }

               this.creationDate = res.creationDate
               ? this.formatDateTime(res.creationDate)
               : new Date();

               this.loadFromDate(res.publishStartDate);
               this.loadToDate(res.publishEndDate);

               this.loading = false;
               this.ignoreTargetTypeChange = false;
            },
            (error) => {
               const status = this.getRequestErrorStatus(error);
               const message = status === 401 || status === 403
                  ? this.$t('wkt.admin.news.edit-window.not_authorized')
                  : this.getRequestErrorMessage(
                     error,
                     'wkt.admin.common.error.try_again_later',
                     'Se ha producido un error, vuelve a intentar esta acción más tarde'
                  );

               if (status === 401 || status === 403) {
                  this.showDialog = false;
                  this.deleteOnCancel = false;
               }

               this.$emit('show-alert', { text: message, color: 'error', timeout: 3000 });
               this.loading = false;
               this.ignoreTargetTypeChange = false;
            }
         );
      },
      getWorkplaceIds() {
         if (!Array.isArray(this.data.newsByWorkplaces)) {
            return [];
         }
         return this.data.newsByWorkplaces.map((x) => x.workplaceId);
      },
      getDepartmentsIds() {
         if (!Array.isArray(this.data.newsByDepartments)) {
            return [];
         }
         return this.data.newsByDepartments.map((x) => x.departmentId);
      },
      getProjectIds() {
         if (!Array.isArray(this.data.newsByProjects)) {
            return [];
         }
         return this.data.newsByProjects.map((x) => x.projectId);
      },
      getLegalEntityIds() {
         if (!Array.isArray(this.data.newsByLegalEntities)) {
            return [];
         }
         return this.data.newsByLegalEntities.map((x) => x.legalEntityId);
      },
      uploadFile() {
         if (!this.file) {
            return;
         }

         const formData = new FormData();
         formData.append('item-id', this.data.id);
         formData.append('file', this.file);

         this.loadingImage = true;
         api.uploadNewsFile(
            formData,
            (res) => {
               this.loadingImage = false;
               this.data.imagePath = res;
               this.imageError = ''; 
            },
            (error) => {
               this.loadingImage = false;
               this.$emit('show-alert', { text: error.message, color: 'error', timeout: 3000 })
            }
         )
      },
      createNewsOnStart() {
         this.data = {};
         this.deleteOnCancel = false;
         this.startTime = null;
         this.endTime = null;
         this.fromDate = null;
         this.fromDateFormatted = '';
         this.toDate = null;
         this.toDateFormatted = '';
         this.formTitle = '';
         this.formSummary = '';
         this.targetManagerType = 0;

         const payload = {
            companyId: null,
            content: '',
            creationDate: new Date().getTime(),
            enabled: false,
            featured: false,
            id: null,
            imagePath: '',
            newsByDepartments: [],
            newsByLegalEntities: [],
            newsByProjects: [],
            newsByWorkplaces: [],
            notified: false,
            publishEndDate: null,
            publishStartDate: null,
            summary: '',
            title: this.$t('wkt.admin.news.pending_completion_news')
         };

         api.storeNews(
            payload,
            (res) => {
            this.data = res;
            this.deleteOnCancel = true;
            this.creationDate = this.formatDateTime(res.creationDate);
            const ts = res.publishStartDate || res.creationDate;
            this.loadFromDate(ts);
            this.toDate = null;
            this.toDateFormatted = '';
            this.endTime = null;
            this.workPlacesList = [];
            this.departmentsList = [];
            this.legalEntitiesList = [];
            this.projectsList = [];
            this.loading = false;
            this.ignoreTargetTypeChange = false;
            },
            (error) => {
            this.$log.error(error);
            this.loading = false;
            this.$emit('show-alert', { text: error, color: 'error', timeout: 3000 });
            this.ignoreTargetTypeChange = false;
            }
         );
      },
      onCancel(){
         if (this.deleteOnCancel) {
            api.deleteNews(this.data.id, 
            () => {
               this.showDialog = false;
               this.loading = false;
               this.$emit('refresh');
            },
            (error) => {
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            });
         }
         this.imageError = '';
         this.contentError='';
         this.showDialog = false;
      },
      getNewsByWorkplace() {
         if (!Array.isArray(this.workPlacesList) || this.workPlacesList.length === 0) {
            return null;
         }
         return this.workPlacesList.map(id => ({
            newsId: this.data.id,
            workplaceId: id
         }));
      },

      getNewsByDepartment() {
         if (!Array.isArray(this.departmentsList) || this.departmentsList.length === 0) {
            return null;
         }
         return this.departmentsList.map(id => ({
            newsId: this.data.id,
            departmentId: id
         }));
      },

      getNewsByLegalEntity() {
         if (!Array.isArray(this.legalEntitiesList) || this.legalEntitiesList.length === 0) {
            return null;
         }
         return this.legalEntitiesList.map(id => ({
            newsId: this.data.id,
            legalEntityId: id
         }));
      },

      getNewsByProject() {
         if (!Array.isArray(this.projectsList) || this.projectsList.length === 0) {
            return null;
         }
         return this.projectsList.map(id => ({
            newsId: this.data.id,
            projectId: id
         }));
      },
      timeStartRule(value){
         if(this.validateStartTime) {
            const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
            return regex.test(value) 
               ? true 
               : this.$t('wkt.admin.common.validation-utils.invalid_field');
         }
      },
      timeRule(value) {
         if (this.mustBeValidatedToDate) {
            const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
            return regex.test(value) 
               ? true 
               : this.$t('wkt.admin.common.validation-utils.invalid_field');          
         }
      },
      updateFormattedDate() {
         if (this.fromDate) {
         this.fromDateFormatted = this.formatISOStringDateToLocalDate(this.fromDate);
         }
         if (this.toDate) {
         this.toDateFormatted = this.formatISOStringDateToLocalDate(this.toDate);
         }
      },
      loadFromDate(timestamp) {
         if (!timestamp) {
            this.fromDate = null;
            this.fromDateFormatted = '';
            this.startTime = null;
            return;
         }

         const dt = new Date(timestamp);
         this.fromDate = dt.toISOString().substr(0, 10);
         this.fromDateFormatted = dt.toLocaleDateString(this.$i18n.locale);
         const horas = String(dt.getHours()).padStart(2, '0');
         const mins = String(dt.getMinutes()).padStart(2, '0');
         this.startTime = `${horas}:${mins}`;
      },
      loadToDate(timestamp) {
         if (!timestamp) {
            this.toDate = null;
            this.toDateFormatted = '';
            this.endTime = null;
            return;
         }

         const dt = new Date(timestamp);
         this.toDate = dt.toISOString().substr(0, 10);
         this.toDateFormatted = dt.toLocaleDateString(this.$i18n.locale);
         const horas = String(dt.getHours()).padStart(2, '0');
         const mins = String(dt.getMinutes()).padStart(2, '0');
         this.endTime = `${horas}:${mins}`;
      },
      getTime(timestamp) {
         if (!timestamp) return null;

         const dateObj = new Date(timestamp);
         const hours = String(dateObj.getHours()).padStart(2, '0');
         const minutes = String(dateObj.getMinutes()).padStart(2,'0');

         return `${hours}:${minutes}`;
      },
      combineDateAndTime(dateStr, timeStr) {
         if (!dateStr || !timeStr) return null;

         const [hours, minutes] = timeStr.split(':').map(Number);

         const date = new Date(dateStr);
         date.setHours(hours);
         date.setMinutes(minutes);
         date.setSeconds(0);
         date.setMilliseconds(0);

         return date.getTime();
      },
      onSave() {
         if (!this.validateForm()) return;

         if (this.fromDate && this.toDate) {
            const startTs = this.combineDateAndTime(this.fromDate, this.startTime);
            const endTs   = this.combineDateAndTime(this.toDate,   this.endTime);
            if (startTs > endTs) {
               this.errorMessages = this.$t('wkt.admin.holidays.calendar.edit-holiday-window.new-record-window.errors.end_date_smaller');
               return;
            }
         }
         this.data.newsByWorkplaces ? this.data.newsByWorkplaces = this.getNewsByWorkplace() : null;
         this.data.newsByDepartments ? this.data.newsByDepartments = this.getNewsByDepartment() : null;
         this.data.newsByLegalEntities ? this.data.newsByLegalEntities = this.getNewsByLegalEntity() : null;
         this.data.newsByProjects ? this.data.newsByProjects = this.getNewsByProject() : null;
         this.data.title = this.formTitle;
         this.data.summary = this.formSummary;
         this.data.publishStartDate = this.combineDateAndTime(this.fromDate, this.startTime);
         this.data.publishEndDate   = this.combineDateAndTime(this.toDate, this.endTime);

         this.loading = true;
         api.storeNews(
            this.data,
            () => {
               this.loading = false;
               this.$emit('refresh');
               this.showDialog = false;
            },
            (error) => {
               this.loading = false;
               this.$emit('show-alert', { text: error, color: 'error', timeout: 3000 });
            }
         );
      },
      validateForm() {
         const formValid = this.$refs.form.validate();

         let imageValid = true;
         if (!this.data.imagePath || this.data.imagePath.trim() === '') {
            this.imageError = this.$t('wkt.admin.common.validation-utils.required_field');
            imageValid = false;
         } else {
            this.imageError = '';
         }

         let contentValid = true;
         const content = this.data.content || '';
         const strippedContent = content.replace(/<[^>]*>/g, '').trim();
         
         if (strippedContent === '') {
         this.contentError = this.$t('wkt.admin.common.validation-utils.required_field');
         contentValid = false;
         } else {
         this.contentError = '';
         }

         return formValid && imageValid && contentValid;
      },
      validateContent(value) {
         if (!value) return this.$t('wkt.admin.common.validation-utils.required_field');
         const stripped = value.replace(/<[^>]*>/g, '').trim();
         return stripped !== '' || this.$t('wkt.admin.common.validation-utils.required_field');
      },
      confirmDelete() {
         this.$refs.dlgConfirm.confirm(this.data);
      },
      deleteItem() {
        this.loading = true;
         api.deleteNews(this.data.id, 
            () => {
               this.showDialog = false;
               this.loading = false;
               this.$emit('refresh');
            },
            (error) => {
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            }
         );
      },
   },
}
</script>
